import iconLogoSmall from "@/assets/icon-logo.webp";
import iconLogoFallback from "@/assets/icon-logo.webp?w=64&format=webp";
import iconLogo from "@/assets/icon-logo.webp?w=64;128&format=webp&as=srcset";
import NoIndex from "@/components/no-index";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

export default function NotFound() {
  return (
    <section className="vouch-gradient hero" aria-label="404 Not Found">
      <NoIndex />
      <div
        className="fade-up mx-auto flex w-full max-w-4xl
        flex-col items-center gap-10 p-5 text-center "
      >
        <img
          src={iconLogoFallback}
          srcSet={iconLogo}
          sizes="64px"
          alt="Sakeena Logo"
          className="w-16 object-contain"
        />
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-normal">There&apos;s nothing here</h1>
          <p className="text-base text-muted-foreground">
            The page you&apos;re looking for doesn&apos;t exist or has moved.
          </p>
        </div>

        <Button size="xl" asChild className="w-full sm:w-fit">
          <Link to="/" replace>
            <img
              src={iconLogoSmall}
              alt="Sakeena logo"
              width={17}
              height={17}
              className="object-contain"
            />{" "}
            Take me home
          </Link>
        </Button>
      </div>
    </section>
  );
}
